import React from 'react';
import { ArrowRightThin } from './vd/LineArt';

// Discreet, single-stroke Facebook line-art mark — matches Val Dotika line-art system
const FacebookLine = ({ size = 22, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    aria-hidden="true"
  >
    <g fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="32" cy="32" r="24" />
      <path d="M36 22h4M36 22c-3 0-5 2-5 5v6h-5m0 6h5v13" />
      <path d="M31 39h8" />
    </g>
  </svg>
);

const CARDS = [
  {
    title: 'Val Dotika na Facebooku',
    desc: 'Novosti, strokovne vsebine, dogodki in utrinki iz našega dela.',
    cta: 'Spremljaj Val Dotika',
    href: 'https://www.facebook.com/profile.php?id=61588315298124',
    testId: 'fb-card-page',
  },
  {
    title: 'Porodniški dopust, ki to ni',
    desc: 'Zasebna skupnost mamic za iskrene pogovore, izkušnje in občutek, da nisi sama.',
    cta: 'Pridruži se skupini',
    href: 'https://www.facebook.com/share/g/1EtE5gmiYx/',
    testId: 'fb-card-group',
  },
];

const FacebookConnect = () => (
  <section
  className="relative py-14 lg:py-20 bg-vd-beige-soft/60 overflow-hidden"
  data-testid="fb-connect-section"
>
      {/* Nežna botanika – nadaljevanje vizualne zgodbe strani */}
    <img
      src="/icons/vd_botanical_mothers_left.png"
      alt=""
      aria-hidden="true"
      className="hidden md:block absolute left-[-9%] top-[-32%] w-[40rem] lg:w-[49rem] opacity-[0.10] pointer-events-none select-none z-0"
    />

    <img
      src="/icons/vd_botanical_mothers_right.png"
      alt=""
      aria-hidden="true"
      className="hidden md:block absolute right-[-9%] top-[-26%] w-[42rem] lg:w-[51rem] opacity-[0.09] pointer-events-none select-none z-0"
    />
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-10">
        <h2 className="font-serif italic text-3xl sm:text-4xl text-vd-text">
          Ostani povezana z Val Dotika
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-5 lg:gap-6">
        {CARDS.map((c) => (
          <a
            key={c.testId}
            href={c.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group block bg-white/90 border border-vd-soft rounded-3xl p-7 sm:p-8 hover:border-vd-primary hover:shadow-md hover:-translate-y-0.5 transition-all"
            data-testid={c.testId}
          >
            <div className="flex items-start gap-4">
              <span className="flex-shrink-0 w-11 h-11 rounded-full bg-vd-primary-soft flex items-center justify-center text-vd-accent">
                <FacebookLine size={22} />
              </span>
              <div className="flex-1">
                <h3 className="font-serif italic text-xl sm:text-2xl text-vd-text mb-2 leading-snug">
                  {c.title}
                </h3>
                <p className="text-sm sm:text-[15px] text-vd-muted leading-relaxed mb-5">
                  {c.desc}
                </p>
                <span className="inline-flex items-center gap-2 text-vd-accent text-sm group-hover:gap-3 transition-all">
                  {c.cta}
                  <ArrowRightThin size={14} />
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default FacebookConnect;
